// extracted by mini-css-extract-plugin
export default {"container":"TextArea_container__YLq7K","input":"TextArea_input__+Voau","input-error":"TextArea_input-error__HP3hA","error-text":"TextArea_error-text__eamO3"};